import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11.5px] font-semibold border whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-surface-alt text-text-soft border-border',
        gray: 'bg-slate-100 text-slate-600 border-transparent',
        indigo: 'bg-primary-soft text-primary-dark border-transparent',
        blue: 'bg-info-soft text-sky-700 border-transparent',
        purple: 'bg-violet-100 text-violet-700 border-transparent',
        amber: 'bg-warning-soft text-amber-800 border-transparent',
        teal: 'bg-teal-100 text-teal-700 border-transparent',
        green: 'bg-success-soft text-green-800 border-transparent',
        red: 'bg-danger-soft text-red-800 border-transparent',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>;

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export function BadgeDot(): JSX.Element {
  return <span className="w-1.5 h-1.5 rounded-full bg-current inline-block" />;
}

export { badgeVariants };
